module.exports = __webpack_public_path__ + "static/media/invaders_ships.f58e3dcb.jpg";